import { apiClient } from "../../../lib";

export const siteApi = {
    createSite: async (params: Record<string, any>): Promise<any> => {
        const response = await apiClient.post('/site', params);
        return response.data;
    },
    getThirdPartySites: async () => {
        const response = await apiClient.get(`/site?is_third_party=true`);
        return response.data;
    },
    getSites: async ({ 
        page = 1, 
        limit = 200, 
        search = "", 
        region = null,
        isThirdParty = null 
    }: { 
        page?: number, 
        limit?: number, 
        search?: string | null, 
        region?: number | string[] | number[] | null,
        isThirdParty?: boolean | null
    }) => {
        const params: Record<string, any> = {
            page, 
            limit, 
            search,
            ...(region && { region_id: region }),
            ...(isThirdParty !== null && { is_third_party: isThirdParty }),
        };
        const response = await apiClient.get('/site', { params });
        return response.data;
    }
};